import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

import { LastDealsTableColumnId } from '@prlw/core/deals/types/last-deals.types';
import {
  LastDeal,
  TLastDealsSummaryItem,
} from '@prlw/core/deals/entities/last-deal.entity';

@Component({
  selector: 'prlw-last-deals-table-content',
  templateUrl: './last-deals-content.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastDealsContentContainer {
  @Input() public columnId!: LastDealsTableColumnId;
  @Input() public deal!: LastDeal | TLastDealsSummaryItem;

  constructor(private readonly datePipe: DatePipe) {}

  checkForTodayOrYesterday(date: Date) {
    const diff = new Date().setHours(0, 0, 0, 0) - date.setHours(0, 0, 0, 0);
    return diff === 0
      ? 'Сегодня'
      : diff === 86400000
        ? 'Вчера'
        : this.datePipe.transform(date, 'd MMMM');
  }

  public get columnData(): string | number | null {
    if ('dealId' in this.deal) {
      const { volume, price, dealId, timestamp } = this.deal;

      const data: { [key: number]: string | number | null } = {
        [LastDealsTableColumnId.VOLUME]: volume,
        [LastDealsTableColumnId.PRICE]: price,
        [LastDealsTableColumnId.DEAL_NUMBER]: dealId,
        [LastDealsTableColumnId.TIME]: this.datePipe.transform(
          timestamp,
          'hh:mm:ss',
        ),
        [LastDealsTableColumnId.DATE]: this.datePipe.transform(
          timestamp,
          'dd.MM.yyyy',
        ),
      };

      return data[this.columnId];
    }

    const { date, totalVolume } = this.deal;

    const data: { [key: number]: string | number | null } = {
      [LastDealsTableColumnId.VOLUME]: totalVolume,
      [LastDealsTableColumnId.PRICE]: null,
      [LastDealsTableColumnId.DEAL_NUMBER]: this.checkForTodayOrYesterday(date),
      [LastDealsTableColumnId.TIME]: null,
      [LastDealsTableColumnId.DATE]: null,
    };

    return data[this.columnId];
  }
}
